<template>
    <!-- 城市-汇付账户 -->
    <div>
        <div style="overflow-y: auto" class="container">
            <div>
                <!-- 按钮状态 -->
                <div>
                    <span style="margin-right: 10px">开启状态 :</span>
                    <el-tag v-if="details.open_status == 1">已开启</el-tag>
                    <el-tag type="danger" v-if="details.open_status == 0">暂未开启</el-tag>
                    <el-button type="primary" @click="createAccount_isShow = !createAccount_isShow" style="margin-left: 20px">创建汇付账户</el-button>

                    <!-- <el-switch v-model="details.open_status" :active-value="1" :inactive-value="0" disabled style="margin-left: 20px">
                </el-switch> -->
                </div>
                <!-- 按钮 -->
                <div
                    style="
                        margin-top: 20px;
                        align-items: center;
                        justify-content: space-between;
                        display: flex;
                        border-bottom: 1px solid #e4e4e4;
                        padding-bottom: 30px;
                    "
                >
                    <div style="display: flex; justify-content: left">
                        <div style="margin-right: 20px">
                            <span>基本信息</span>
                            <el-button v-if="details.huifu_id != ''" size="mini" disabled style="margin-left: 20px" type="info"
                                >已填写</el-button
                            >

                            <el-button v-else type="primary" style="margin-left: 20px" @click="editBtn">编辑</el-button>
                        </div>

                        <div>
                            <span>企业入驻</span>

                            <el-button v-if="details.token_no != ''" size="mini" disabled style="margin-left: 20px" type="info"
                                >已填写</el-button
                            >

                            <el-button v-else size="mini" style="margin-left: 20px" type="primary" @click="open_isShow = !open_isShow"
                                >编辑</el-button
                            >
                        </div>
                        <div style="line-height: 28px; margin-left: 10px">
                            <span>手续费率 </span>
                            <span>{{ fee_rate }} %</span>
                            <el-tooltip class="item" effect="dark" content="交易类手续费（订单交易，客户余额充值）" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                    </div>

                    <!-- 提现，充值，充值记录按钮 -->
                    <div style="display: flex; justify-content: right">
                        <el-button type="primary" @click="tixian_isShow = !tixian_isShow">提现</el-button>

                        <!-- <el-button type="primary" @click="rechargeBtn">对公账户充值</el-button> -->
                        <el-button type="primary" @click="rechargeGeRen">账户充值</el-button>
                        <el-button type="primary" @click="income_isShow = !income_isShow">充值记录</el-button>
                    </div>
                </div>
                <!-- 账户余额 -->
                <div style="display: flex; justify-content: space-between; margin-top: 20px; width: 80%">
                    <div class="text-box">
                        <span>账户余额 </span>
                        <span>{{ balance.balance_amt }} 元</span>
                    </div>
                    <!-- <div class="text-box">
                        <span>可用余额 </span>
                        <span>{{ balance.avl_bal }} 元</span>
                    </div> -->
                    <div class="text-box">
                        <!-- 当前城市司机钱包余额的总和 -->
                        <span>司机余额 </span>
                        <span>{{ balance.driver_balance_sum }} 元</span>
                    </div>
                    <div class="text-box">
                        <!-- 当前城市乘客和司机充值到汇付的钱的总和 -->
                        <span>累计交易金额 </span>
                        <span>{{ balance.trade_sum }} 元</span>
                    </div>
                    <div class="text-box">
                        <!-- 当前城市司机从汇付提出去的总和。 -->
                        <span>累计提现金额 </span>
                        <span>{{ balance.withdraw_sum }} 元</span>
                    </div>
                    <!-- <div class="text-box">
                        <span>冻结余额 </span>
                        <span>{{ balance.frz_bal }} 元</span>
                    </div>
                    <div class="text-box">
                        <span>昨日日终余额 </span>
                        <span>{{ balance.last_avl_bal }} 元</span>
                    </div> -->
                    <!-- <div class="text-box">
                        <span>手续费率 </span>
                        <span>{{ fee_rate }} %</span>
                    </div> -->
                </div>

                <!-- <div class="text-box">
                <span>活动账号余额 </span>
                <p>{{ active_balance.active_balance }} 元</p>
            </div>
            <div class="text-box">
                <span>累计充值活动金额 </span>
                <p>{{ active_balance.total_active_amount }} 元</p>
            </div>
            <div class="text-box">
                <span>已使用活动金额 </span>
                <p>{{ active_balance.used_active_amount }} 元</p>
            </div> -->

                <div
                    v-if="amountIsShow"
                    style="border: 1px solid #e4e4e4; border-radius: 10px; width: 500px; padding: 20px; margin: 10px auto"
                >
                    <div class="text-box">
                        <span>金额 </span>
                        <el-input v-model="amount" placeholder="余额" style="width: 200px; margin-left: 10px"> </el-input>
                    </div>
                    <div class="text-box">
                        <span>类型 </span>
                        <el-select v-model="submit_data.income_type" placeholder="请选择类型" style="width: 200px; margin-left: 10px">
                            <el-option label="司机服务费" value="1"> </el-option>
                            <!-- <el-option label="活动金" value="0"> </el-option> -->
                        </el-select>
                    </div>
                    <div style="display: flex; justify-content: center">
                        <el-button type="primary" @click="submitBtn">支付</el-button>
                    </div>
                </div>
            </div>

            <div style="margin-top: 30px; border-top: 1px solid #e4e4e4; padding-top: 30px">
                <div class="handle-box-search1">
                    <div class="handle-box">
                        <el-row class="head-search">
                            <el-col :span="12">
                                <span class="title">类型:</span>
                                <!-- 搜索类型 -->
                                <el-select
                                    v-model="search_data.desc"
                                    placeholder="请选择类型"
                                    style="width: 150px; margin-right: 20px"
                                    clearable
                                >
                                    <el-option :label="item" :value="item" v-for="(item, index) in payColumnArray" :key="index">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="12">
                                <span class="title">交易时间:</span>
                                <!-- 搜索时间 -->

                                <el-date-picker
                                    v-model="search_time"
                                    type="datetimerange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="timeChange"
                                    style="width: 350px"
                                >
                                </el-date-picker>
                            </el-col>
                        </el-row>
                    </div>
                    <el-button type="primary" icon="el-icon-search" @click="searchAcctLog">搜索</el-button>

                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                    <el-button :icon="!progress_show ? 'el-icon-setting' : 'el-icon-loading'" @click="toExport" :disabled="progress_show">{{
                        progress_show ? '正在导出...' : '导出'
                    }}</el-button>
                    <div style="width: 500px; margin: 10px auto" v-if="progress_show">
                        <el-progress :percentage="progress_data"></el-progress>
                        <i class="el-icon-loading"></i>
                        正在导出...
                    </div>
                </div>

                <!-- 表格 -->
                <el-table
                    style="margin-top: 20px"
                    :data="tableData"
                    class="table"
                    ref="multipleTable"
                    header-cell-class-name="table-header"
                    v-loading="loading"
                >
                    <el-table-column prop="req_seq_id" label="流水号"> </el-table-column>
                    <el-table-column prop="hf_seq_id" label="汇付全局流水号"> </el-table-column>

                    <el-table-column prop="amount" label="金额"> </el-table-column>

                    <el-table-column prop="status" label="状态"> </el-table-column>
                    <el-table-column prop="fail_reason" label="状态描述"> </el-table-column>
                    <el-table-column prop="description" label="分类"> </el-table-column>
                    <el-table-column prop="time_stamp" label="交易时间"> </el-table-column>
                </el-table>

                <!-- element ui 原生分页组件 -->
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="search_data.page"
                        :page-sizes="[10, 20, 30, 40, 50]"
                        :page-size="search_data.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="result_data.count"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 基本信息组件 -->
        <addDialog :isShow="add_isShow" @onSubmit="getDetails"></addDialog>

        <!-- 企业入驻组件 -->
        <openDialog :isShow="open_isShow" @onSubmit="getDetails"> </openDialog>

        <!-- 充值记录组件 -->
        <incomeLog :isShow="income_isShow"> </incomeLog>

        <!-- 提现组件 -->
        <tixian :isShow="tixian_isShow" @onSubmit="getDetails"></tixian>
        <!-- 充值二维码组件 -->
        <recharge :isShow="recharge_isShow" @onSubmit="getDetails"></recharge>

        <!-- 创建汇付账户 -->
        <createAccount :isShow="createAccount_isShow"></createAccount>
    </div>
</template>

<script>
let _this;
import recharge from './recharge.vue';

import openDialog from './openDialog.vue';
import addDialog from './addDialog.vue';
import incomeLog from './incomeLog.vue';
import tixian from './tixian.vue';
import createAccount from './createAccount.vue';
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    components: {
        openDialog,
        addDialog,
        incomeLog,
        tixian,
        recharge,
        createAccount
    },
    data() {
        return {
            recharge_isShow: false,

            loading: true,
            progress_show: false,
            progress_data: 0,
            excelData: [],

            open_isShow: false,
            add_isShow: false,
            income_isShow: false,
            tixian_isShow: false,
            createAccount_isShow: false,
            amount: '',
            tableData: [],
            payColumnArray: [],
            search_time: '',

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                desc: '',
                time_fixed_array: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            result_data: [],

            active_balance: {
                total_active_amount: 0,
                used_active_amount: 0,
                active_balance: 0
            },
            fee_rate: '',
            balance: {
                balance_amt: '', // 账户余额
                // avl_bal: '', // 可用余额
                // frz_bal: '', // 冻结金额
                // last_avl_bal: '', // 昨日日终余额
                driver_balance_sum: '', // 司机余额
                trade_sum: '', // 累计交易金额
                withdraw_sum: '' // 累计提现金额
            },
            submit_data: {
                amount: '',
                income_type: ''
            },
            submit_rules: {
                amount: {
                    placeholder: '余额',
                    rules: {
                        required: true,
                        message: '余额需要大于0的数字',
                        regulation: 'number',
                        rulesData: 0
                    }
                },
                income_type: {
                    placeholder: '类型',
                    rules: {
                        required: true,
                        message: '类型为必填项',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            },

            amountIsShow: false,

            details: {}
        };
    },
    created() {
        _this = this;

        _this.getDetails();
        _this.searchAcctLog();
        _this.payColumn();
    },
    methods: {
        // 个人账户充值
        rechargeGeRen() {
            _this.recharge_isShow = !_this.recharge_isShow;
        },
        toExport() {
            _this.search_data.page = 1;

            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/huifu/acctLog', _this.search_data, _this.search_rules_children)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.$route.path == '/huifu') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                req_seq_id: res.data[i].req_seq_id,
                                hf_seq_id: res.data[i].hf_seq_id,

                                amount: res.data[i].amount,
                                status: res.data[i].status,
                                fail_reason: res.data[i].fail_reason,
                                description: res.data[i].description,
                                time_stamp: res.data[i].time_stamp
                            });
                        }

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;
                            _this.progress_data = Math.floor(((_this.search_data.page * _this.search_data.limit) / res.count) * 100);
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '流水号',
                '汇付全局流水号',

                '金额',
                '状态',
                '成功或失败描述',
                '分类',
                '交易时间'

                // '操作账号',
                // '操作人姓名'
            ];
            const filterVal = [
                'req_seq_id',
                'hf_seq_id',

                'amount',
                'status',
                'fail_reason',
                'description',
                'time_stamp'

                // 'operator',
                // 'operator_name'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '汇付账户');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },
        // 选择日期
        timeChange(val) {
            if (val != null) {
                _this.search_data.time_fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.time_fixed_array = '';
            }
            _this.searchAcctLog();
        },
        //获取支付类型
        payColumn() {
            // 更改axios请求的baseURL
            // axios.defaults.baseURL = config.axios_normalURL;
            _this
                .$post('/home/payColumn',{},{},'normal')
                .then((res) => {
                    // 还原axios请求的baseURL
                    // axios.defaults.baseURL = config.axios_baseURL;

                    _this.payColumnArray = res.data;
                })
                .catch((err) => {});
            // 还原axios请求的baseURL
            // axios.defaults.baseURL = config.axios_baseURL;
        },
        //搜索列表
        acctLog() {
            _this
                .$post('/huifu/acctLog', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.loading = false;

                    _this.result_data = res;
                    _this.tableData = res.data;
                })
                .catch((err) => {});
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.acctLog(); //解决勾选数据后翻页无数据问题
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.acctLog(); //解决勾选数据后翻页无数据问题
        },

        //搜索列表
        searchAcctLog() {
            _this.search_data.page = 1;

            _this.acctLog();
        },
        // 基本信息编辑方法
        editBtn() {
            _this.add_isShow = !_this.add_isShow;
        },

        // 点击充值按钮方法
        rechargeBtn() {
            _this.amountIsShow = !_this.amountIsShow;
        },

        // 充值支付
        submitBtn() {
            _this.submit_data.amount = Number(_this.amount).toFixed(2); // 输入1提交数据的时候变成1.00

            _this
                .$post('/huifu/income', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.getDetails();
                    window.location.href = res.data.form_url;
                })
                .catch((err) => {});
        },

        // 详情
        getDetails() {
            _this.$post('/huifu/details').then((res) => {
                _this.details = res.data;
                _this.active_balance.total_active_amount = res.data.active_balance.total_active_amount;
                _this.active_balance.used_active_amount = res.data.active_balance.used_active_amount;
                _this.active_balance.active_balance = res.data.active_balance.active_balance;
                _this.balance.balance_amt = res.data.balance.balance_amt; // 账户余额
                // _this.balance.avl_bal = res.data.balance.avl_bal; // 可用余额
                // _this.balance.frz_bal = res.data.balance.frz_bal; // 冻结金额
                // _this.balance.last_avl_bal = res.data.balance.last_avl_bal; // 昨日日终余额
                _this.balance.trade_sum = res.data.balance.trade_sum; // 累计交易金额
                _this.balance.driver_balance_sum = res.data.balance.driver_balance_sum; // 司机余额
                _this.balance.withdraw_sum = res.data.balance.withdraw_sum; // 累计提现金额
                _this.fee_rate = res.data.fee_rate; // 手续费率
            });
        },
    }
};
</script>

<style scoped>
.text-box {
    width: 260px;
    height: 100px;
    line-height: 100px;
    border: 1px solid #e4e4e4;
    border-radius: 10px;
    text-align: center;
}
</style>
